// Property-specific constants shown to guests. Single property -> hardcoded.
// Update + redeploy if any of these change.

export const PROPERTY = {
  addressLine1: "Calle Miguel Zazo, 13",
  addressLine2: "52004 Melilla, Spain",
  apartment: "2A",
  elevatorFloor: "3",
} as const;

const fullAddress = `${PROPERTY.addressLine1}, ${PROPERTY.addressLine2}`;

// Google's universal Maps search URL. On iOS, Safari offers to open in Apple
// Maps; on Android / desktop it opens Google Maps. Single button, no UA
// sniffing required.
export const PROPERTY_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  fullAddress
)}`;
